import * as React from "react";
const SvgFiRrDriverWoman = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-driver-woman_svg__a)">
      <path
        fill="#062147"
        d="M21.936 22.89c.061.549-.32 1.11-.995 1.11a1 1 0 0 1-.993-.89A7.983 7.983 0 0 0 12.001 16a7.983 7.983 0 0 0-7.947 7.11 1 1 0 1 1-1.988-.22A9.983 9.983 0 0 1 12.002 14a9.983 9.983 0 0 1 9.936 8.89zM3.873 12.822c.308-1.306 1.854-7.849 2.026-8.385A6.39 6.39 0 0 1 12 0a6.39 6.39 0 0 1 6.1 4.437c.174.536 1.72 7.079 2.028 8.385a1 1 0 0 1-1.947.459c-.7-2.968-1.857-7.827-1.984-8.23a4.38 4.38 0 0 0-1.675-2.256 6.67 6.67 0 0 1-2.67 3.185 6.7 6.7 0 0 1-3.546 1.021c-.055 0-.111-.008-.167-.01C8.583 8.716 10.138 10 12 10c.703 0 1.395-.185 1.999-.535a1 1 0 0 1 1.002 1.731 5.997 5.997 0 0 1-8.172-2.169c-.344 1.439-.717 3.01-1.01 4.253a1 1 0 0 1-1.946-.458m3.969-7.864a4.67 4.67 0 0 0 2.952-.675 4.7 4.7 0 0 0 1.863-2.23 4.392 4.392 0 0 0-4.815 2.905M12 18a6.016 6.016 0 0 0-5.879 4.801 1 1 0 1 0 1.96.398A4.01 4.01 0 0 1 12 20a4.01 4.01 0 0 1 3.92 3.199 1 1 0 1 0 1.959-.398A6.015 6.015 0 0 0 12 18"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-driver-woman_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDriverWoman;
